let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fPL37")).then(() => parcelRequire('dkej0'));